import React from "react";
import PropTypes from "prop-types";

export const IconButton = ({
    as: Component = "button",
    ariaLabel,
    className = "",
    icon,
    title,
    type = "button",
    variant = "outline",
    ...props
}) => {
    const classes = [
        "btn",
        "hms-icon-button",
        `hms-button--${variant}`,
        className,
    ].filter(Boolean).join(" ");

    const componentProps = {
        "aria-label": ariaLabel,
        className: classes,
        title: title || ariaLabel,
        ...props,
    };

    if (Component === "button") {
        componentProps.type = type;
    }

    return <Component {...componentProps}>{icon}</Component>;
};

IconButton.propTypes = {
    as: PropTypes.elementType,
    ariaLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
    icon: PropTypes.node.isRequired,
    title: PropTypes.string,
    type: PropTypes.string,
    variant: PropTypes.oneOf(["primary", "secondary", "outline", "danger", "warning", "info"]),
};
